export default __webpack_public_path__ + "assembly0e6339d.png";